if (
  document.querySelector("#confirmation-form") &&
  document.querySelector("#submit-customer")
) {
  window.onload = function () {
    let url = document
      .getElementById("confirmation-form")
      .getAttribute("data-url");

    let xhr = new XMLHttpRequest();
    xhr.open("POST", url);
    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");

    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4 && xhr.status === 200) {
        document.getElementById("form-container").innerHTML = xhr.responseText;
      }
    };

    xhr.send();
  };

  let button = document.querySelector("#submit-customer");

  /* TODO: Implement a more efficient and less buggy way to check if the form has been modified
    button.disabled = true;

    let form = document.querySelector('#customer-form');
    const initialState = new Map(Array.from((new FormData(form)).entries()));
    let currentState = initialState
    let stateChanged = false;

    form.addEventListener('input', function(event) {
        currentState = new FormData(form);
        if (event.target.matches('input, select, textarea')) {
            stateChanged = Array.from(initialState.entries()).some(([name, value]) => {
                return currentState.get(name) !== value;
            }) || Array.from(currentState.entries()).some(([name, value]) => {
                return initialState.get(name) !== value;
            });        
        }
        button.disabled = !stateChanged;
    });

    let observer = new MutationObserver(function(mutations) {
        let nodeCount = 0;

        mutations.forEach(mutation => {
            mutation.addedNodes.forEach(node => {
                nodeCount++;
            });
    
            mutation.removedNodes.forEach(node => {
                nodeCount--;
            });

            currentState = new FormData(form);

            stateChanged = !(nodeCount === 0)            
        });
        button.disabled = !stateChanged;
    });

    observer.observe(form, { childList: true, subtree: true });
    */

  function confirmClose() {
    document.querySelector("#confirmation-form").classList.add("hidden");
  }
  button.addEventListener("click", function (event) {
    event.preventDefault();

    if (document.querySelector("#customer-form").checkValidity()) {
      document.querySelector("#confirmation-form").classList.remove("hidden");

      jQuery.magnificPopup.open(
        {
          items: { src: "#confirmation-form" },
          closeOnBgClick: false,
          closeBtnInside: true,
          type: "inline",
        },
        0
      );
    } else {
      document.querySelector("#customer-form").reportValidity();
    }
  });

  var verificationMethod;

  function setVerificationMethod() {
    let methods = document.getElementsByName(
      "data_verification[verificationType]"
    );
    for (let i = 0; i < methods.length; i++) {
      if (methods[i].checked) {
        verificationMethod = methods[i].value;
        break;
      }
    }
  }

  $(document).on("submit", "#confirmation-form form", function (event) {
    event.preventDefault();

    let formData = new FormData(event.target);

    $.ajax({
      url: document
        .querySelector("#confirmation-form")
        .getAttribute("data-url"),
      type: "POST",
      data: formData,
      processData: false,
      contentType: false,
      success: function (response, textStatus, jqXHR) {
        // check the http response code
        if (jqXHR.status === 201) {
          $("#customer-form").submit();
        } else {
          setVerificationMethod();
          let closeButton = document.querySelector(
            "#confirmation-form > button"
          );
          $("#confirmation-form").html(response);
          $("#confirmation-form").prepend(closeButton);
          initializeCountdown();
          bindResendEvent();
        }
      },
      error: function (jqXHR, textStatus, errorThrown) {
        console.log(jqXHR.responseText);
      },
    });
  });

  function initializeCountdown() {
    var resend = document.getElementById("resend");
    var countdown = document.getElementById("countdown");
    const startTime = 60;
    var countdownInterval;

    function startCountdown() {
      let remainingTime = startTime;
      resend.disabled = true;
      resend.classList.add("inactive");
      countdown.innerText = "(" + remainingTime + ")";
      countdownInterval = setInterval(() => {
        remainingTime--;
        countdown.innerText = "(" + remainingTime + ")";
        if (remainingTime <= 0) {
          clearInterval(countdownInterval);
          resend.disabled = false;
          resend.classList.remove("inactive");
          countdown.innerText = "";
        }
      }, 1000);
    }

    var resetCountdown = function () {
      resend.disabled = true;
      clearInterval(countdownInterval);
      startCountdown();
    };

    window.startCountdown = startCountdown;
    window.resetCountdown = resetCountdown;
    window.startCountdown();
  }
  function bindResendEvent() {
    resend.addEventListener("click", function (event) {
      event.preventDefault();
      if (UIEvent.which == 13) {
        return false;
      }
      resend.disabled = true;
      resend.classList.add("inactive");
      countdown.innerText = "...";

      let xhr = new XMLHttpRequest();
      xhr.open("POST", "/admin/data-verification", true);
      xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
      xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {
          countdown.innerText = "Sent!";
          resetCountdown(); // Reset the countdown timer to 60
        } else {
          countdown.innerText = " Error!";
        }
      };
      let data =
        "flow_dataVerification_transition=resend&verificationMethod=" +
        encodeURIComponent(verificationMethod);
      xhr.send(data);
    });
  }
}
